import cx from "../../../lib/cx";
import Button from "../Button/Button.jsx";
import { Variants } from "../Button/Variants.jsx";
import styles from "./checklistItem.css.js";

/**
 * Renders a checklist item component, that optionally provides a link that can open in a new tab.
 *
 * @param {string} name - The unique name/id of the checkbox input.
 * @param {string} label - The text label for the checkbox input.
 * @param {string} link - The URL of the link to be displayed (optional).
 * @param {string} linkTitle - The title attribute for the link (optional).
 * @param {boolean} checked - Indicates whether the checkbox input is checked (default: false).
 * @param {boolean} required - Indicates whether the checkbox input is required (default: false).
 * @param {function} onChange - The event handler for the checkbox input's "change" event.
 * @param {boolean} error - Indicates whether the checkbox input has an error (optional).
 * @param {boolean} colorInherit - false - Whether to inherit the parents color (true) or use default grey (false)
 * @return {JSX.Element} - The rendered checklist item component.
 * @constructor
 */

function ChecklistItem({
  name,
  label,
  link,
  linkTitle,
  checked = false,
  required = false,
  onChange,
  error,
  colorInherit = false,
}) {
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.target.click();
    }
  };
  return (
    <div
      className={cx(
        styles.control,
        error && styles.error,
        checked && styles.checked,
        colorInherit && styles.colorInherit,
      )}
    >
      <div className={styles.mainContent}>
        <input
          onKeyDown={handleKeyDown}
          type="checkbox"
          className={styles.input}
          name={name}
          id={name}
          required={required}
          checked={checked}
          onChange={onChange}
          role="checkbox"
          tabIndex={0}
        />

        <label className={styles.label} htmlFor={name}>
          {label}
        </label>
      </div>

      {link && (
        <a href={link} title={linkTitle} rel="noreferrer" target="_blank">
          <Button
            iconLeft="open"
            variant={Variants.TERTIARY}
            width="fit-content"
          />
        </a>
      )}
    </div>
  );
}

export default ChecklistItem;
